import { gql } from '@apollo/client';

export const createTreaty = gql`
  mutation CreateTreaty($treaty: TreatyData) {
    createTreaty(treaty: $treaty)
  }
`;


export const updateTreatyReinsurers = gql`
  mutation CreateReinsurersTreatyDistribution(
    $ids: [Reinsurer_representative_data]
    $treaty_id: ID
    $layer_number: [Int]
    $treaty_associate_deduction_id: ID
  ) {
    createReinsurersDistribution(
      reinsurer_ids: $ids
      treaty_id: $treaty_id
      layer_number: $layer_number
      treaty_associate_deduction_id: $treaty_associate_deduction_id
    )
  }
`;

export const createTreatyEndorsement = gql`
mutation CreateTreatyEndorsement(
  $treatyId: ID!
  $treatyEndorsementComment: String
) {
  createTreatyEndorsement(
    treaty_id: $treatyId
    treaty_endorsement_comment: $treatyEndorsementComment
  )
}
`;

export const updateTreatyEndorsement = gql`
mutation UpdateTreatyEndorsement(
  $treatyEndorsementId: ID!
  $treatyEndorsementComment: String!
) {
  updateTreatyEndorsement(
    treaty_endorsement_id: $treatyEndorsementId
    treaty_endorsement_comment: $treatyEndorsementComment
  )
}

`;

export const updateTreatyReinsurersDeductions = gql`
mutation UpdateReinsurerDeductions(
  $data: [ReinsurerParticipationUpdate]
  $account_ids: [ID]
  $isProp: Boolean
  $layer: String
) {
  updateReinsurerDeductions(
    data: $data
    account_ids: $account_ids
    isProp: $isProp
    layer: $layer
  )
}
`;

export const sendNPTreatyCreditNote = gql`
  mutation SendNpCreditNOte($data: NPTreatyData) {
    sendNPTreatyCreditNote(nptreatydata: $data)
  }
`;

export const makeReceivablePayment = gql`
mutation MakeReceivablePayment(
  $treatyId: ID!
  $receivablePayments: ReceivablePaymentInput!
) {
  makeReceivablePayment(
    treaty_id: $treatyId
    receivable_payments: $receivablePayments
  )
}

`;

export const sendTreatyBrokerNotes = gql`
  mutation SendTreatyBrokerNotes(
    $treaty_id: ID
    $treaty_account_id: ID
    $re_broker_treaties_participation_id: ID
    $emaildata: EmailComponent
  ) {
    sendTreatyBrokerNotes(
      treaty_id: $treaty_id
      treaty_account_id: $treaty_account_id
      re_broker_treaties_participation_id: $re_broker_treaties_participation_id
      emaildata: $emaildata
    )
  }
`;

export const sendPTreatyCreditAndStatementNote = gql`
 mutation SendPTreatyCreditAndStatementNote(
    $treaty_account_id: [ID]
    $participant_id: ID
    $docType: [String]
    $treaty_id: ID
    $email_component: EmailComponent
  ) {
    sendPTreatyCreditAndStatementNote(
      treaty_account_id: $treaty_account_id
      email_component: $email_component
      treaty_id: $treaty_id
      participant_id: $participant_id
      type: $docType
    )
  }
`;

export const updateTreatyBrokers = gql`
  mutation CreateReBrokerListForTreaty($brokersList: BrokerDistributionList) {
    createReBrokerListForTreaty(brokers_list: $brokersList)
  }
`;

export const recordReceivablePayment = gql`
mutation RecordReceivablePayment(
  $treatyId: ID
  $receivablePayments: [ReceivablePaymentInput]
) {
  recordReceivablePayment(
    treaty_id: $treatyId
    receivable_payments: $receivablePayments
  )
}

`;

export const sendCoverAndPlacingNotes = gql`
  mutation SendTreatyPlacingOrCovertNote(
    $treaty_id: ID
    $doc_type: String
    $emaildata: EmailComponent
  ) {
    sendTreatyPlacingOrCovertNote(
      treaty_id: $treaty_id
      doc_type: $doc_type
      emaildata: $emaildata
    )
  }
`;

export const createAndUpdatePortfolioStatmentAndProfitCommission = gql`
  mutation CreateAndUpdatePortfolioStatment(
    $treaty_proportional_detail_id: ID
    $overall_gross_premium: Float
    $losses: Float
    $prev_year_configuration: PrevYearConfigurationData
    $known_losses: KnownLossesData
  ) {
    createAndUpdatePortfolioStatmentAndProfitCommission(
      treaty_proportional_detail_id: $treaty_proportional_detail_id
      overall_gross_premium: $overall_gross_premium
      losses_outstanding: $losses
      prev_year_configuration: $prev_year_configuration
      known_losses: $known_losses
    )
  }
`;
export const updateTreatyForPlaingAndCover = gql`
  mutation UpdateTreatyForPlaingAndCover(
    $treaty_id: ID
    $treaty_details: String
  ) {
    updateTreatyForPlaingAndCover(
      treaty_id: $treaty_id
      treaty_details: $treaty_details
    )
  }
`;

export const removetreatyReinsurer = gql`
  mutation RemoveReinsurersParticipationPercentage($treatyParticipationId: ID) {
    removeReinsurersParticipationPercentage(
      treaty_participation_id: $treatyParticipationId
    )
  }
`;
export const removeAssociateFromTreaty = gql`
mutation RemoveAssociateFromTreaty($treatyToAssociateId: ID) {
  removeAssociateFromTreaty(treaty_to_associate_id: $treatyToAssociateId)
}

`;
export const removetreatyBroker = gql`
  mutation RemoveReBokerFromTreatyList(
    $reBrokerTreatiesParticipationId: ID
    $treatyId: ID
  ) {
    removeReBokerFromTreatyList(
      re_broker_treaties_participation_id: $reBrokerTreatiesParticipationId
      treaty_id: $treatyId
    )
  }
`;

export const deleteTreatyEndorsement = gql`
mutation DeleteTreatyEndorsement($treatyEndorsementId: ID!) {
  deleteTreatyEndorsement(treaty_endorsement_id: $treatyEndorsementId)
}
`;

export const deleteAdjustmentStatment = gql`
  mutation DeleteAdjustmentStatment($treaty_id: ID, $treaty_np_detail_id: ID) {
    deleteAdjustmentStatment(
      treaty_id: $treaty_id
      treaty_np_detail_id: $treaty_np_detail_id
    )
  }
`;

export const updateTreatyReinsurerPercentage = gql`
 mutation AddReinsurersParticipationPercentage(
  $treatyParticipationId: ID!
  $layerNumber: Int!
  $participationPercentage: Float!
  $treatyId: ID!
  $associateDeductionId: ID!
) {
  addReinsurersParticipationPercentage(
    treaty_participation_id: $treatyParticipationId
    layer_number: $layerNumber
    participation_percentage: $participationPercentage
    treaty_id: $treatyId
    associate_deduction_id: $associateDeductionId
  )
}

`;

export const addQuarter = gql`
  mutation AddQuarterForTreaty($data: TreatyAccountData) {
    addQuarterForTreaty(treaty_account: $data)
  }
`;

export const duplicateTreatyCurrency = gql`
mutation DuplicateTreaty($treaty_id: ID, $currencies: [String]) {
    duplicateTreaty(treaty_id: $treaty_id, currencies: $currencies)
  }
    `;

export const updateLimitLayer = gql`
mutation UpdateLimitLayer($limit: LimitData) {
  updateLimitLayer(limit: $limit)
}

`;

export const createOrUpdateAdjustmentStatment = gql`
mutation CreateOrUpdateAdjustmentStatment(
    $treaty_id: ID
    $outstanding_payment: Float
    $claim_paid: Float
    $treaty_np_detail_id: ID
    $retained_premium_income: Float
  ) {
    createOrUpdateAdjustmentStatment(
      treaty_id: $treaty_id
      claims_paid: $claim_paid
      outstanding_payment: $outstanding_payment
      treaty_np_detail_id: $treaty_np_detail_id
      retained_premium_income: $retained_premium_income
    )
  }
`;


export const updateQuarter = gql`
  mutation UpdateQuarterForTreaty(
    $treatyAccount: TreatyAccountData
    $treatyAccountId: ID
  ) {
    updateQuarterForTreaty(
      treaty_account: $treatyAccount
      treaty_account_id: $treatyAccountId
    )
  }
`;

export const removeQuarterForTreaty = gql`
mutation RemoveQuarterForTreaty($treatyAccountId: ID) {
  removeQuarterForTreaty(treaty_account_id: $treatyAccountId)
}
`;


export const sendNPTreatyDebitNote = gql`
mutation SendNPTreatyDebitNote($nptreatydata: NPTreatyData) {
  sendNPTreatyDebitNote(nptreatydata: $nptreatydata)
}

`;
